import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useGetVehicleModels } from "../../queries/useGetVehicleModels";
import { useGetVehicleSubmodels } from "../../queries/useGetVehicleSubmodels";
import { useIsLoggedOn } from "../../stores/hooks/useIsLoggedOn";
import { usePackageEditor } from "../../stores/hooks/usePackageEditor";
import { Button } from "../../ui/Button/Button";
import { usePackageEditorSetting } from "../../util/usePackageEditorSetting";
import { useOrderDetails } from "../Cart/useOrderDetails";
import { useNewPackageDialog } from "./NewPackageDialog/NewPackageDialog";
import { getNewPackageId } from "./NewPackageDialog/getNewPackageId";
import { createVehicleMappingKey } from "./createVehicleMappingKey";

export const CreatePackageButton: FunctionComponent<{
  className?: string;
  id: string;
}> = ({ className, id }) => {
  const hasPackageEditor = usePackageEditorSetting();
  const { data: orderDetails } = useOrderDetails();
  const { t } = useTranslation();
  const [, { show }] = useNewPackageDialog();
  const isLoggedOn = useIsLoggedOn();
  const [, { initializePackage }] = usePackageEditor(
    getNewPackageId(orderDetails)
  );

  const { vehicleModelId, vehicleYearId } = useGetVehicleModels();
  const { selectedSubmodel } = useGetVehicleSubmodels();

  if (!hasPackageEditor || !isLoggedOn) {
    return null;
  }

  return (
    <Button
      onClick={(): void => {
        const vehicleMappingKeys =
          vehicleModelId && selectedSubmodel && vehicleYearId
            ? [
                createVehicleMappingKey({
                  vehicleModelId,
                  vehicleSubmodelId: selectedSubmodel.value,
                  vehicleYearId: String(vehicleYearId),
                }),
              ]
            : null;
        initializePackage(vehicleMappingKeys);
        show();
      }}
      aria-label="createPackage"
      className={clsx("bg-ink text-paper w-full h-14", className)}
      id={id}
    >
      {t("dealerTireTile.createPackage")}
    </Button>
  );
};
